import ListItemText from "@mui/material/ListItemText";
import { ReactComponent as DeviceTablet } from "assets/DeviceTablet.svg";
import { ReactComponent as Gift } from "assets/Gift.svg";
import { ReactComponent as Key } from "assets/Key.svg";
import CloseIconButton from "../lib/CloseIconButton";
import { Fragment, useEffect } from "react";
import {
	StyledDialog,
	StyledDialogTitle,
	StyledDialogContent,
	StyledDialogContentText,
	StyledDialogActions,
	StyledActionsBox,
	StyledList,
	StyledListItem,
	StyledListItemIcon,
	StyledListHeading
} from "./styled";
import {
	useWebStoreContext,
	useEnvContext,
	useScopelyIdentityContext,
	useFacebookContext
} from "contexts";
import BackToGameButton from "components/Buttons/BackToGameButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";

const DialogYourAccountIsNotConnected = ({
	show,
	onCloseClick,
	onConnect
}: {
	show: boolean;
	onCloseClick: () => void;
	onConnect: () => void;
}) => {
	const { cdnPrefix } = useEnvContext();
	const { setCurrentOffer } = useWebStoreContext();
	const { setFbAccessToken } = useFacebookContext();
	const { setScopelyIdToken, setScopelyAccessToken, setScopelyIdentityToken } =
		useScopelyIdentityContext();
	const backgroundImage = `url(${cdnPrefix}/spec_dialogs/facebook-connect-background.png)`;
	const scale = useCalculateScale(400 + 25, 464 + 5);

	useEffect(() => {
		setCurrentOffer(null);
	}, []);

	// * Temporary cleanup for stale Scopely tokens after account-not-connected redirect.
	useEffect(() => {
		if (show) {
			setScopelyIdToken(null);
			setScopelyAccessToken(null);
			setScopelyIdentityToken(null);
			setFbAccessToken(null);
		}
	}, [show]);

	return (
		<StyledDialog scale={scale} open={show} onClose={onCloseClick}>
			<StyledDialogTitle sx={{ backgroundImage }}>
				<img
					src={`${cdnPrefix}/spec_dialogs/facebook-connect-foreground.png`}
				/>
				<CloseIconButton onClose={onCloseClick} />
			</StyledDialogTitle>
			<StyledDialogContent>
				<StyledDialogContentText>
					<StyledListHeading>Your Account Is Not Connected</StyledListHeading>
					<ListContent />
				</StyledDialogContentText>
			</StyledDialogContent>
			<StyledDialogActions>
				<StyledActionsBox>
					<BackToGameButton
						onClick={() => onConnect()}
						source={"account_not_connected_dialog"}
						styles={{ width: "180px", height: "45px" }}
					>
						Connect
					</BackToGameButton>
				</StyledActionsBox>
			</StyledDialogActions>
		</StyledDialog>
	);
};

const ListContent = () => {
	return (
		<StyledList>
			<StyledListItem>
				<StyledListItemIcon>
					<DeviceTablet />
				</StyledListItemIcon>
				<ListItemText
					primary="Return to Tiki Solitaire TriPeaks"
					secondary={
						<Fragment>
							Go back to Tiki Solitaire TriPeaks on your device
						</Fragment>
					}
				/>
			</StyledListItem>
			<StyledListItem>
				<StyledListItemIcon>
					<Key />
				</StyledListItemIcon>
				<ListItemText
					primary="Connect Your Account"
					secondary={
						<Fragment>
							To purchase in the Web Shop, you must have your Tiki Solitaire
							Tripeaks account connected to either Facebook or Scopely. If you
							haven&lsquo;t yet done this, open the game, go to MENU, and tap
							ACCOUNTS. From there, connect to either your existing Facebook or
							Scopely account. If you don&lsquo;t have either, tap the HELP
							button for assistance
						</Fragment>
						// <Fragment>
						// 	To purchase in the Web Shop, you must have your Tiki Solitaire
						// 	Tripeaks account connected to Facebook or Scopely. If not, open
						// 	the game, go to MENU {">"} ACCOUNTS, and connect to your existing
						// 	account. If you don&lsquo;t have either, tap HELP for assistance.
						// </Fragment>
					}
				/>
			</StyledListItem>
			<StyledListItem>
				<StyledListItemIcon>
					<Gift />
				</StyledListItemIcon>
				<ListItemText
					primary="Return to Web Shop"
					secondary={
						<Fragment>
							Enjoy browsing the website for now, and when you&lsquo;re ready to
							make a purchase, connect your account to either Facebook or
							Scopely
						</Fragment>
					}
				/>
			</StyledListItem>
		</StyledList>
	);
};

export { DialogYourAccountIsNotConnected };
